<div class="morador-card">
  <div class="morador-card__header">
    <h2>{{ morador.nome }}</h2>
    <ion-button size="small" class="ion-no-margin" fill="clear" color="danger" (click)="cancelarProgramaSuperSocial()">
      <ion-icon slot="start" name="trash"></ion-icon>
      Deletar
    </ion-button>
  </div>
  <div class="morador-card__content">
    <p><b>RG:</b> {{ morador.rg }}</p>
    <p><b>CPF:</b> {{ morador.cpf | mask: '000.000.000-00'}}</p>
    <p><b>Estado civil:</b> {{ morador.estadoCivil | estadoCivil }}</p>
    <p><b>Renda declarada:</b> {{ morador.renda | currency: 'BRL' }}</p>
    <p><b>Profissão:</b> {{ morador.profissao }}</p>
  </div>
  <div class="morador-card__footer">
    <ion-button mode="md" expand="block" fill="outline" (click)="irParaEdicao()">
      Editar Informações
    </ion-button>
  </div>
</div>